$(document).ready(function() {
  (function(){
    const sameDayDeliveryCollection = 'same-day'; // Collection handle for same-day delivery
    let minDate = 1; // Default minimum date is +1 day

    // Get the cutoff hour from the global namespace metafield
    //const deliveryCutoffHour = {{ delivery_cutoff_hour | json}};
//console.log("Delivery Cutoff Hour:", deliveryCutoffHour);
   // console.log("Unavailable Dates:", unavailableDates);

    // Check if the product is part of the same-day delivery collection
    if (productCollections.includes(sameDayDeliveryCollection)) {
        const nowUK = new Date(new Date().toLocaleString("en-US", { timeZone: "Europe/London" }));
        if (nowUK.getHours() < deliveryCutoffHour) {
            minDate = 0; // Allow same-day delivery if before cutoff hour
        }
    }

    function formatDate(date) {
        if (!(date instanceof Date)) {
            console.error("Invalid date provided to formatDate:", date);
            return null;
        }
        const day = ("0" + date.getDate()).slice(-2);
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear().toString().slice(-2);
        return `${day}-${month}-${year}`; // Format as 'dd-mm-yy'
    }

    function isSunday(date) {
        return date.getDay() === 0;
    }

    function isUnavailableDate(date) {
        const formattedDate = formatDate(date);
        return unavailableDates.includes(formattedDate);
    }

function isSameDayAfter2PM(date) {
    // Ensure deliveryCutoffHour is provided and valid
    if (typeof deliveryCutoffHour !== "number") {
        throw new Error("deliveryCutoffHour must be a valid number.");
    }
 
    // Current time in "Europe/London"
    const now = new Date();
    const formatter = new Intl.DateTimeFormat('en-US', { 
        timeZone: "Europe/London",
        year: "numeric", month: "2-digit", day: "2-digit",
        hour: "2-digit", minute: "2-digit", second: "2-digit"
    });

    const partsNow = formatter.formatToParts(now);
    const nowUK = new Date(
        `${partsNow[0].value}-${partsNow[2].value}-${partsNow[4].value}T${partsNow[6].value}:${partsNow[8].value}:${partsNow[10].value}`
    );

    // Evaluate the passed date in "Europe/London"
    const partsDate = formatter.formatToParts(date);
    const dateUK = new Date(
        `${partsDate[0].value}-${partsDate[2].value}-${partsDate[4].value}T00:00:00`
    );

    // Compare dates: same day and time after cutoff
    if (dateUK.toDateString() === nowUK.toDateString()) {
        return nowUK.getHours() >= deliveryCutoffHour;
    }

    return false; // Not the same day
}


    function getFirstAvailableDate(minDate) {
        let date = new Date(new Date().toLocaleString("en-US", { timeZone: "Europe/London" }));
        date.setDate(date.getDate() + minDate);

        // Check if the first available date is a Sunday or same day after 2 PM
        while((minDate === 0 && isSameDayAfter2PM(date)) || isUnavailableDate(date)) {
            date.setDate(date.getDate() + 1);
        }

        return date;
    }

    const firstAvailableDate = getFirstAvailableDate(minDate);

     // Store the first available date in a hidden input
    $('#first_available_date').val(formatDate(firstAvailableDate));
    
    // Initialize the date picker with the determined minimum date and disabled Sundays
    $('#delivery_date_picker').datepicker({
        dateFormat: 'dd-mm-yy',
        minDate: firstAvailableDate,
        beforeShowDay: function(date) {
            return [!isSameDayAfter2PM(date) && !isUnavailableDate(date)];
        },
        onSelect: function(dateText) {
            $("#hidden_delivery_date").val(dateText);
           // $("#ProductSubmitButton-{{ section_id }}").prop("disabled", false); // Enable the button
            $("#selected_delivery_date").text("Selected Delivery Date: " + dateText); // Show the selected date
        }
    });

    // Set the default date to the first available date
    $('#delivery_date_picker').datepicker('setDate', firstAvailableDate);
    $("#hidden_delivery_date").val($.datepicker.formatDate('dd-mm-yy', firstAvailableDate));
    //$("#ProductSubmitButton-{{ section_id }}").prop("disabled", false); // Enable the button
    $("#selected_delivery_date").text("Selected Delivery Date: " + $.datepicker.formatDate('dd-mm-yy', firstAvailableDate)); // Show the selected date

    // Add an event listener to the "Add to Cart" button
    $('form[action="/cart/add"]').submit(function(event) {
        event.preventDefault(); // Prevent the default form submission

        // Get the selected delivery date from the hidden input field
        const deliveryDate = $("#hidden_delivery_date").val();
        if (!deliveryDate) {
            // Display an error message or perform any other action to indicate that a delivery date is required
            return; // Exit the function without submitting the form
        }

        // Add the delivery date to the form data
        $(this).append('<input type="hidden" name="properties[Delivery Date]" value="' + deliveryDate + '">');
        $(this).unbind('submit').submit(); // Submit the form
    });
    })();
});